import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import BigImage from '../../components/BigImage'
import Paginate from '../../components/Paginate'
import SectionHeader from '../../components/SectionHeader'
import Stories from '../../components/Stories'
import SummaryBullet from '../../components/SummaryBullet'
import Text from '../../components/Text'
import patient from '../../stores/patient'

@observer
export default class GoalSession1 extends Component {
  render() {
    return (
      <Fragment>
        {/* STORIES */}
        <SectionHeader color="red" icon="fas fa-users" str="titles.stories" />
        <BigImage src={patient.ethnicityImage} />
        <Stories hidePrompts={true} />
        {/* SUMMARY */}
        <SectionHeader color="red" icon="fas fa-users" str="titles.summary" />
        <SummaryBullet
          color="red"
          icon={(
            (patient.fields.importance >= 7 && 'fas fa-smile') ||
            (patient.fields.importance >= 4 && 'fas fa-meh') ||
            'fas fa-frown'
          )}
        >
          <Text str="prose.importanceOfTakingDrops" />
          {` ${patient.fields.importance} / 10`}
        </SummaryBullet>
        <SummaryBullet
          color="red"
          icon={(
            (patient.fields.confidence >= 7 && 'fas fa-smile') ||
            (patient.fields.confidence >= 4 && 'fas fa-meh') ||
            'fas fa-frown'
          )}
        >
          <Text str="prose.confidenceCanImprove" />
          {` ${patient.fields.confidence} / 10`}
        </SummaryBullet>
        {patient.fields.importance < 7 && patient.hasMotivations &&
          <SummaryBullet color="red" icon="fas fa-handshake">
            <Text str="prose.youreMotivatedBy" />&nbsp;
            {patient.fields.motivations.map((v, i) => (
              <Fragment key={i}>
                <Text str={`choices.motivation.${v}`} />
                {i !== patient.fields.motivations.length - 1 && ', '}
              </Fragment>
            ))}
          </SummaryBullet>
        }
        {patient.fields.confidence < 7 && patient.hasStrengths &&
          <SummaryBullet color="red" icon="fas fa-heart">
            <Text str="prose.yourStrengthsAre" />&nbsp;
            {patient.fields.strengths.map((v, i) => (
              <Fragment key={i}>
                <Text str={`choices.strength.${v}`} />
                {i !== patient.fields.strengths.length - 1 && ', '}
              </Fragment>
            ))}
          </SummaryBullet>
        }
        {/* PAGINATE */}
        <Paginate>
          <Paginate.Button prev
            color="orange"
            str="titles.use"
            to="/patient-session/use"
          />
          <Paginate.Button next
            color="yellow"
            str="titles.adherence"
            to="/patient-session/adherence"
          />
        </Paginate>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/PatientSession/GoalPage.js